import { axios } from 'common/axios';

import { ReleaseNote } from 'common/types/release-note.type';
import { BrowserSessionTrace } from 'common/types/browser-session-trace.type';

export const getSettingsByNames = async (): Promise<any> => {
  const url = '/api/settings/';
  const { data } = await axios.get(url);

  return data;
};

export const updateSetting = async (updatedSettings: any): Promise<any> => {
  const url = '/api/settings/';
  const { data } = await axios.put(url, updatedSettings);

  return data;
};

export const addThirdPartyApplicationStatus = async ({
  status,
}: {
  status: any;
}): Promise<any> => {
  const url = '/api/settings/status';

  const { data } = await axios.put(url, { status });

  return data;
};

export const deleteThirdPartyApplicationStatus = async ({
  status,
}: {
  status: any;
}): Promise<any> => {
  const url = `/api/settings/status/${status}`;

  const { data } = await axios.delete(url);

  return data;
};

export const deleteApplicationsUsersInfoStatus = async ({
  status,
}: {
  status: any;
}): Promise<any> => {
  const url = `/api/settings/applications-users-info-status/${status}`;

  const { data } = await axios.delete(url);

  return data;
};

export const addApplicationStatus = async ({
  status,
}: {
  status: any;
}): Promise<any> => {
  const url = '/api/settings/applications-status';

  const { data } = await axios.put(url, { status });

  return data;
};

export const addApplicationsUsersInfoStatus = async ({
  status,
}: {
  status: string;
}): Promise<{ success: boolean }> => {
  const url = '/api/settings/applications-users-info-status';

  const { data } = await axios.put(url, { status });

  return data;
};

export const deleteApplicationStatus = async ({
  status,
}: {
  status: any;
}): Promise<any> => {
  const url = `/api/settings/applications-status/${status}`;

  const { data } = await axios.delete(url);

  return data;
};

export const getStatusSettings = async ({ status }: { status: any }) => {
  const url = `/api/settings/status/${status}`;

  const { data } = await axios.get(url);

  return data;
};

export const setStatusSettings = async (statusObject: any): Promise<any> => {
  const url = '/api/settings/status';

  const { data } = await axios.post(url, statusObject);

  return data;
};

export const addCustomStandard = async ({
  title,
  article,
}: {
  title: string;
  article?: string;
}): Promise<{ success: boolean }> => {
  const url = '/api/settings/custom-standards';

  const { data } = await axios.put(url, { title, article });

  return data;
};

export const updateCustomStandard = async ({
  title,
  article,
}: {
  title: string;
  article: string;
}): Promise<{ success: boolean }> => {
  const url = '/api/settings/custom-standards';

  const { data } = await axios.post(url, { title, article });

  return data;
};

export const deleteCustomStandard = async ({
  title,
}: {
  title: string;
}): Promise<{ content: string }> => {
  const url = `/api/settings/custom-standards?title=${encodeURIComponent(
    title,
  )}`;

  const { data } = await axios.delete(url);

  return data;
};

export const fetchLargeExportsRecipientsOptions = async (): Promise<{
  content: string[];
}> => {
  const url = '/api/settings/large-exports-recipients';
  const { data } = await axios.get(url);

  return data;
};

export const fetchReleaseNotes = async ({
  search,
}: {
  search?: string;
}): Promise<{
  content: ReleaseNote[];
}> => {
  const url = '/api/settings/release-notes';
  const { data } = await axios.get(url, {
    params: { search },
  });

  return data;
};

export const previewReleaseNote = async ({
  filename,
}: {
  filename: string;
}): Promise<Blob> => {
  const url = '/api/settings/release-notes/preview';
  const { data } = await axios.get(url, {
    responseType: 'blob',
    params: { filename },
  });

  return data;
};

export const downloadReleaseNotes = async ({
  filenames,
}: {
  filenames: string[];
}): Promise<Blob> => {
  const url = '/api/settings/release-notes/download';
  const { data } = await axios.post(
    url,
    { filenames },
    {
      responseType: 'blob',
    },
  );

  return data;
};

export const getBrowserSessionTraces = async (): Promise<{
  traces: BrowserSessionTrace[];
}> => {
  const url = '/api/settings/browser-session-traces/';
  const { data } = await axios.get(url);

  return data;
};

export const getBrowserSessionTracePresignedUrl = async ({
  key,
}: {
  key: string;
}): Promise<{ url: string }> => {
  const url = '/api/settings/browser-session-traces/presigned-url/';
  const { data } = await axios.get(url, {
    params: { key },
  });

  return data;
};
